<template>
    <ListPVApproval platform="pv_fm" nameTable="fm---facilities-management-payment-voucher"/>
</template>
<script>
    const ListPVApproval = () => import('./list-pv-approval')
    export default {
        name: 'list-pv-approval-fm',
        components: {
            ListPVApproval
        }
    }
</script>